import * as THREE from 'three';
import videotextureShader from '../shaders/videotexture';

export function createVideoShaderMaterial(videoTexture, options = {}) {
    const {
        edgeTransparency = 0.15,
        globalOpacity = 0.85
    } = options;

    return new THREE.ShaderMaterial({
        uniforms: {
            videoTexture: { value: videoTexture },
            edgeTransparency: { value: edgeTransparency },
            uTime: { value: 0.0 },
            globalOpacity: { value: globalOpacity }
        },
        vertexShader: videotextureShader.vert,
        fragmentShader: videotextureShader.frag,
        transparent: true
    });
}
